<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <v-chip size="small" variant="tonal">
    <v-icon start size="16" icon="inventory_2" />
    {{ t('component.iconArchived.archived') }}
  </v-chip>
</template>

<style scoped lang="scss"></style>
